export default __webpack_public_path__ + "static/wave_video-fb7225ff1e0e18945fc6664d77151d2c.svg";